/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable nordic/i18n-jsx-no-literals */
const React = require('react');
const Computer = require('./Images/computer');
const Mobile = require('./Images/mobile');
const { useLiveDemoContext } = require('./Provider/liveDemoContext');
const { getEventTracker } = require('../../../../utils/event-tracker');

const Resolution = ({ i18n, liveDemoId }) => {
  const Tracker = getEventTracker();
  const { setFormData, formData } = useLiveDemoContext();

  function updateState(value) {
    setFormData(prev => ({
      ...prev,
      resolution: value,
    }));
  }

  return (<div className="live-demo-resolution">
    <span className="live-demo-resolution-label">
      {i18n.gettext('Dispositivo')}
    </span>
    <div className="live-demo-wrapper">
      <input
        type="radio"
        name="select"
        id="live-demo-option-1"
        defaultChecked={formData.resolution === 'desktop'}
        onClick={() => {
          Tracker.send(`mpdevelopers/live_demo/select_resolution_${liveDemoId}`, 'computer');
          updateState('desktop');
        }}
      />
      <input
        type="radio"
        name="select"
        id="live-demo-option-2"
        defaultChecked={formData.resolution === 'mobile'}
        onClick={() => {
          Tracker.send(`mpdevelopers/live_demo/select_resolution_${liveDemoId}`, 'phone');
          updateState('mobile');
        }}
      />
      <label htmlFor="live-demo-option-1" className="live-demo-option live-demo-option-1">
        <Computer alt={i18n.gettext('Computadora')} />
        <span>{i18n.gettext('Computadora')}</span>
      </label>
      <label htmlFor="live-demo-option-2" className="live-demo-option live-demo-option-2">
        <Mobile alt={i18n.gettext('Teléfono')} />
        <span>{i18n.gettext('Teléfono')}</span>
      </label>
    </div>
          </div>);
};

module.exports = Resolution;
